import type { ResponseInterceptor } from '../../types';
import type { CorePx } from '@fanduel/cpe-um-bundle/core-px/library';

// Core PX module lazy loader
let corePxModulePromise: Promise<{ CorePx: typeof CorePx }> | null = null;
const getCorePx = async () => {
    if (!corePxModulePromise) {
        corePxModulePromise = import('@fanduel/cpe-um-bundle/core-px/library');
    }
    return corePxModulePromise;
};

export const pxResponseInterceptor: ResponseInterceptor = async (req, res, next) => {
    // Server-side: skip PX
    if (typeof window === 'undefined') {
        return next(req, res);
    }

    if (res.status === 403) {
        const cloneRes = res.clone();
        const { CorePx } = await getCorePx();

        try {
            const body = await res.json();
            const result = await CorePx.handleFailedRequest(body, res.status, req.input.toString());

            if (result.type === 'HandledSuccessfully') {
                const retryHeaders = new Headers(req.init?.headers);
                // `PxRequestHeaders` is `{ [key: string]: string }` per the upstream
                // `@fanduel/core-px-js-contract`, but pnpm's strict isolation breaks
                // that resolution from `@fanduel/cpe-um-bundle@2.0.2` → `@fanduel/core-px@9.0.7`
                // (the latter references the contract package without declaring it as a dep),
                // so `result.newHeaders` collapses to a type where values are `unknown`.
                const newHeaders = result.newHeaders as Record<string, string>;
                Object.entries(newHeaders).forEach(([k, v]) => retryHeaders.set(k, v));

                const retryInit: RequestInit = { ...req.init, headers: retryHeaders };

                const newResponse = await fetch(req.input, retryInit);

                return next(req, newResponse);
            }

            return next(req, cloneRes);
        } catch (err) {
            console.error('[PX] handleFailedRequest threw', req.input, err);
            return next(req, cloneRes);
        }
    }

    return next(req, res);
};
